// src/pages/hr/HRTravel.jsx
import React from "react";
import HRComingSoon from "./HRComingSoon";

export default function HRTravel() {
  return (
    <HRComingSoon
      icon="✈️"
      title="Travel Management"
      description="Manage business travel requisitions, approvals, booking coordination, and travel expense reconciliation. Coming soon."
    />
  );
}
